export class RequestIdError extends Error {
    method: string | undefined; 

    constructor (method: string) {
        super(method);
    }
}